import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
        /* latin */
        @font-face {
          font-family: 'DoubleBass';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('./DoubleBass-Bold-trial.ttf') format('ttf'),url('./DoubleBass-Light-trial.ttf') format('ttf'),url('./DoubleBass-Regular-trial.ttf') format('ttf'), url('./DoubleBass-Thin-trial.ttf') format('ttf');
        }
      /* latin */
      @font-face {
        font-family: 'Bryndan Write';
        font-style: normal;
        src: url('./BryndanWrite.ttf') format('ttf');
      }
      `}
  />
);

export default Fonts;
